import { CohortModel, FetchAllUsers, FetchCohorts } from "@mikros/library";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { FormattedMessage, useIntl } from "react-intl";
import { format } from "date-fns";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
  createTheme,
} from "@mui/material";
import { useRef, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import ApiServices from "../../../service/apiService";
import { AddNewUsersDup } from "./addNewUsersDup";

export interface AddFilterUserProps {
  cohortListState: Function;
  addNewState: Function;
  currentCohort: CohortModel;
  coh: FetchCohorts;
  addNewUpdate: () => void;
  delBut: Function;
  refreshedCohorts: () => void;
}

export function AddFilterUser(props: AddFilterUserProps) {

  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const intl = useIntl();
  const maxUserNameLimit = 50;

  const [searchClicked, setSearchClicked] = useState<boolean>(false);

  const [userFetchModel, setUserFetchModel] = useState<FetchAllUsers>({
    users: [],
    lastKey: "",
  });
  const hasMoreData = useRef(true);
  const [formData, setFormData] = useState({
    firstName: "",
    branchName: "",
    department: "",
    location: "",
    designation: "",
    email: "",
    phNo: "",
  });

  const languages = ["English", "Hindi", "Tamil", "is empty"];
  const allValue = "All";

  const [selectedLanguage, setSelectedLanguage] = useState<string[]>([
    ...languages,
  ]);
  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [searchActive, setSearchActive] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({}); // Ensure it's an object
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const nameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);
  const workRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&#${}()\-\[\]]+$/);
  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const maxCharLimit = 50;
  const validators = {
    userNameValidator: (value: string) =>
      value === "" || nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "analytics.userView.userNameValidation",
          })}`,

    deptRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.departmentValidation",
          })}`,
    desgRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.designationValidation",
          })}`,
    branchRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.branchValidation" })}`,
    locationRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.locationValidation" })}`,
    // emailRegexValidator: (value: string) =>
    //   value
    //     ? emailRegex.test(value)
    //       ? ""
    //       : `${intl.formatMessage({
    //           id: "user.createUser.emailValidation",
    //         })}`
    //     : "",
    // mobileRegexValidator: (value: string) =>
    //   value
    //     ? mobileRegex.test(value)
    //       ? ""
    //       : `${intl.formatMessage({
    //           id: "shareCustomer.mobileNumberValidation",
    //         })}`
    //     : "",
  };
  const columns = [
    {
      field: "userId",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.userId" }),
    },
    {
      field: "empId",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.employee" }),
    },
    {
      field: "userProfile.firstName",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.fname" }),
    },
    {
      field: "userProfile.lastName",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.lname" }),
    },
    {
      field: "email",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.email" }),
    },
    {
      field: "phNo",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.phNo" }),
    },
    {
      field: "dateOfJoin",
      title: intl.formatMessage({
        id: "user.searchUser.gridColumn.dateOfJoin",
      }),
    },
    {
      field: "userProfile.dob",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.dob" }),
    },
    {
      field: "userProfile.gender",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.gender" }),
    },
    {
      field: "prefrdLanguage",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.language" }),
    },
    {
      field: "department",
      title: intl.formatMessage({
        id: "user.searchUser.gridColumn.department",
      }),
    },
    {
      field: "designation",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.desg" }),
    },
    {
      field: "location",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.location" }),
    },
    {
      field: "branchName",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.branch" }),
    },
    {
      field: "status",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.status" }),
    },
  ];
  const existingCohortList = props?.coh?.cohortUsers?.map(
    (user) => user.userId
  );
  console.log("existing cohort list", existingCohortList);
  const formatDOJRequired = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = format(date, "yyyy-MM-dd");
    return formattedDate;
  };
  const formatDOBRequired = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = format(date, "yyyy-MM-dd");
    return formattedDate;
  };

  const renderValue = (selected: string[]) => {
    if (selected.length === languages.length) {
      return allValue;
    }
    return selected.join(",");
  };
  const handleItemClick = (lang: string) => {
    let updatedSelection = [...selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === languages.length) {
      updatedSelection = [...languages];
    }
    setSelectedLanguage(updatedSelection);
  };
  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    console.log("Inside handle search:", formData);

    setSearchClicked(true);

    //  Build the query string dynamically
    console.log("user fetch model", userFetchModel);
    const filters = [
      "firstName",
      "branchName",
      "department",
      "location",
      "designation",
      "email",
      "phNo",
    ];
    const isAllSelected = selectedLanguage.length === languages.length;

    const languageQuery = isAllSelected
      ? ""
      : selectedLanguage
          .map((lang) => (lang === "is empty" ? "isEmpty" : lang)) // Replace "is empty" with "isEmpty"
          .join(",");

    const queryParams = [
      ...(isAllSelected || !languageQuery
        ? [] // Omits 'languages' completely when all are selected
        : [`languages=${encodeURIComponent(languageQuery)}`]),
      ...Object.entries(formData)
        .filter(([_, value]) => typeof value === "string" && value.trim()) // Remove empty fields
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value.trim())}`
        ),
    ].join("&");

    const apiUrl = `${accountInstance.accntId}/user/filter${
      queryParams ? `?${queryParams}` : ""
    }`;

    const api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api.makeRequest(apiUrl, "GET").then(async (data) => {
        if (data && data?.errorMessage) {
          console.log("I entered error code handling in users");
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data?.errorMessage);
          return;
        } else {
          // const activeUsers =
          //   data?.users?.filter((user: any) => user.status === "ACTIVE") || [];

          const activeUsers =
            data?.users?.filter(
              (user: any) =>
                user.status === "ACTIVE" &&
                !existingCohortList?.includes(user.userId)
            ) || [];

          setUserFetchModel({ ...data, users: activeUsers });
          setTotalUserCount(activeUsers.length);
          setSearchActive(true);
          const hasDataLeft = data?.lastKey !== null;
          hasMoreData.current = hasDataLeft;
        }
      });
    }
  };

  const handleClear = (field: string) => {
    // setFormData({
    //   ...formData,
    //   [field]: "",
    // });
    setFormData({
      ...formData,
      [field]: "",
    });

    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  const handleClearAll = () => {
    setFormData({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
      email: "",
      phNo: "",
    });
    setErrors({});

    if (searchClicked) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            // `${accountInstance.accntId}/user/filter`,
            `${accountInstance.accntId}/user?limit=20`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              console.log("I entered error code handling in users");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
              return;
            } else {
              // const activeUsers =
              //   data?.users?.filter((user: any) => user.status === "ACTIVE" ) ||
              //   [];

              const activeUsers = data?.users?.filter(
                (user: any) =>
                  user.status === "ACTIVE" &&
                  !existingCohortList?.includes(user.userId)
              );

              setUserFetchModel({ ...data, users: activeUsers });
              setTotalUserCount(activeUsers.length);
              // setSearchActive(true);
              setSearchActive(false);
              setSelectedLanguage([allValue]);
              handleItemClick(allValue);
              hasMoreData.current = true;
            }
          });
      }
      setSearchClicked(false); // Reset the search click status
    }
  };

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    console.log("inside handl change name", name);
    console.log("inside handle change value", value);
    // Validate and keep the error until the entire input is valid
    // const errorMsg = validators.userNameValidator(value);
    let errorMsg = "";
    if (name === "firstName") {
      console.log("inside user name validator");
      errorMsg = validators.userNameValidator(value);
    } else if (name === "branchName") {
      console.log("inside branch validator");
      errorMsg = validators.branchRegexValidator(value);
    } else if (name === "department") {
      console.log("inside dept validator");
      errorMsg = validators.deptRegexValidator(value);
    } else if (name === "location") {
      console.log("inside location validator");
      errorMsg = validators.locationRegexValidator(value);
    } else if (name === "designation") {
      console.log("inside desg validator");
      errorMsg = validators.desgRegexValidator(value);
    } else if (name === "phNo") {
      console.log("inside phNo validator");
      // errorMsg = validators.mobileRegexValidator(value);
    } else if (name === "email") {
      console.log("inside email validator");
      // errorMsg = validators.emailRegexValidator(value);
    }

    setErrors((prev: any) => ({
      ...prev,
      [name]: errorMsg, // Only update the specific field
    }));
  };
  return (
    <div>
      <div className="pb-[2%]"></div>
      <div className="text-mk-primary-bright text-2xl font-semibold">
        <FormattedMessage id="analytics.userView.searchUsers" />
      </div>
      <Card sx={{ p: 1, mb: 2 }}>
        <CardContent>
          <form onSubmit={handleSearch}>
            <div className="grid grid-cols-3 gap-2">
              <div>
                <FormControl margin="dense" sx={{ width: "16rem" }}>
                  <Typography variant="subtitle1">
                    <FormattedMessage id="analytics.userView.userName" />
                  </Typography>
                  <TextField
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    InputLabelProps={{ shrink: false }}
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    sx={{
                      "& input:-webkit-autofill, & input:-webkit-autofill:focus, & input:-webkit-autofill:hover, & input:-webkit-autofill:active":
                        {
                          WebkitBoxShadow:
                            "0 0 0 1000px white inset !important", // Apply white background within bounds
                          WebkitTextFillColor: "black !important",
                          transition:
                            "background-color 9999s ease-out 0s !important",
                          height: "0.005rem !important",
                        },
                    }}
                    inputProps={{ maxLength: maxUserNameLimit }}
                    InputProps={{
                      disableUnderline: true,
                      style: { backgroundColor: "white" },
                      endAdornment: (
                        <InputAdornment position="end">
                          {formData.firstName && (
                            <IconButton
                              onClick={() => handleClear("firstName")}
                              edge="end"
                              size="small"
                              sx={{
                                backgroundColor: "transparent",
                                "&:hover": {
                                  backgroundColor: "#E1E2E9",
                                },
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
              <div>
                <FormControl margin="dense" sx={{ width: "16rem" }}>
                  <Typography variant="subtitle1">
                    {/* Branch */}
                  <FormattedMessage id="user.textBoxCreation.emailId"/>
                  </Typography>
                  <TextField
                    error={!!errors.email}
                    helperText={errors.email}
                    InputLabelProps={{ shrink: false }}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    inputProps={{ maxLength: maxCharLimit }}
                    InputProps={{
                      disableUnderline: true,
                      style: { backgroundColor: "white" },
                      endAdornment: (
                        <InputAdornment position="end">
                          {formData.email && (
                            <IconButton
                              onClick={() => handleClear("email")}
                              edge="end"
                              size="small"
                              sx={{
                                backgroundColor: "transparent",
                                "&:hover": {
                                  backgroundColor: "#E1E2E9",
                                },
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>

              <div>
                <FormControl margin="dense" sx={{ width: "16rem" }}>
                  <Typography variant="subtitle1">
                    {/* Department */}
                    <FormattedMessage id="user.textBoxCreation.mobileNumber"/>
                  </Typography>
                  <TextField
                    error={!!errors.phNo}
                    helperText={errors.phNo}
                    InputLabelProps={{ shrink: false }}
                    name="phNo"
                    value={formData.phNo}
                    onChange={handleChange}
                    inputProps={{ maxLength: maxCharLimit }}
                    InputProps={{
                      disableUnderline: true,
                      style: { backgroundColor: "white" },
                      endAdornment: (
                        <InputAdornment position="end">
                          {formData.phNo && (
                            <IconButton
                              onClick={() => handleClear("phNo")}
                              edge="end"
                              size="small"
                              sx={{
                                backgroundColor: "transparent",
                                "&:hover": {
                                  backgroundColor: "#E1E2E9",
                                },
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2">
              <div>
                <FormControl margin="dense" sx={{ width: "16rem" }}>
                  <Typography variant="subtitle1">
                    {/* Location */}
                    <FormattedMessage id="analytics.userView.location" />
                  </Typography>
                  <TextField
                    error={!!errors.location}
                    helperText={errors.location}
                    InputLabelProps={{ shrink: false }}
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    inputProps={{ maxLength: maxCharLimit }}
                    InputProps={{
                      disableUnderline: true,
                      style: { backgroundColor: "white" },
                      endAdornment: (
                        <InputAdornment position="end">
                          {formData.location && (
                            <IconButton
                              onClick={() => handleClear("location")}
                              edge="end"
                              size="small"
                              sx={{
                                backgroundColor: "transparent",
                                "&:hover": {
                                  backgroundColor: "#E1E2E9",
                                },
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
              <div>
                <FormControl margin="dense" sx={{ width: "16rem" }}>
                  <Typography variant="subtitle1">
                    {/* Designation */}
                    <FormattedMessage id="analytics.userView.desg" />
                  </Typography>
                  <TextField
                    error={!!errors.designation}
                    helperText={errors.designation}
                    InputLabelProps={{ shrink: false }}
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    inputProps={{ maxLength: maxCharLimit }}
                    InputProps={{
                      disableUnderline: true,
                      style: { backgroundColor: "white" },
                      endAdornment: (
                        <InputAdornment position="end">
                          {formData.designation && (
                            <IconButton
                              onClick={() => handleClear("designation")}
                              edge="end"
                              size="small"
                              sx={{
                                backgroundColor: "transparent",
                                "&:hover": {
                                  backgroundColor: "#E1E2E9",
                                },
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
              <div>
                <FormControl margin="dense" sx={{ width: "16rem" }}>
                  <Typography variant="subtitle1">
                    {/* Designation */}
                    <FormattedMessage id="user.textBoxCreation.department"/>
                  </Typography>
                  <TextField
                    error={!!errors.department}
                    helperText={errors.department}
                    InputLabelProps={{ shrink: false }}
                    name="department"
                    value={formData.department}
                    onChange={handleChange}
                    inputProps={{ maxLength: maxCharLimit }}
                    InputProps={{
                      disableUnderline: true,
                      style: { backgroundColor: "white" },
                      endAdornment: (
                        <InputAdornment position="end">
                          {formData.department && (
                            <IconButton
                              onClick={() => handleClear("department")}
                              edge="end"
                              size="small"
                              sx={{
                                backgroundColor: "transparent",
                                "&:hover": {
                                  backgroundColor: "#E1E2E9",
                                },
                              }}
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2">
              {/* <div> */}
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  {/* Location */}
                  <FormattedMessage id="user.textBoxCreation.branch"/>
                </Typography>
                <TextField
                  error={!!errors.branchName}
                  helperText={errors.branchName}
                  InputLabelProps={{ shrink: false }}
                  name="branchName"
                  value={formData.branchName}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: (
                      <InputAdornment position="end">
                        {formData.branchName && (
                          <IconButton
                            onClick={() => handleClear("branchName")}
                            edge="end"
                            size="small"
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": {
                                backgroundColor: "#E1E2E9",
                              },
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
             <FormattedMessage id="addFilterUser.language"/>
                  </Typography>
                <Select
                  labelId="language-select-label"
                  id="language-select"
                  multiple
                  value={selectedLanguage}
                  onChange={handleChange}
                  // input={<OutlinedInput label="Language" />}
                  renderValue={renderValue}
                  // MenuProps={MenuProps}
                >
                  {/* "All" option */}
                  <MenuItem
                  disableRipple
                    key={allValue}
                    value={allValue}
                    onClick={() => handleItemClick(allValue)}
                  >
                    <Checkbox
                     disableRipple
                      checked={selectedLanguage.length === languages.length}
                      sx={{
                        "&.Mui-checked": { color: "var-mk-very-dark-grey" },
                      }}
                    />
                    <ListItemText primary={allValue} />
                  </MenuItem>

                  {/* Individual language options */}
                  {languages.map((lang) => (
                    <MenuItem
                    disableRipple
                      key={lang}
                      value={lang}
                      onClick={() => handleItemClick(lang)}
                    >
                      <Checkbox 
                       disableRipple
                      checked={selectedLanguage.includes(lang)} />
                      <ListItemText primary={lang} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* </div> */}
              {/* <div className="flex justify-end items-end"> */}
              <div className="flex justify-start items-center space-x-2">
                <Button
                  type="submit"
                  variant="contained"
                  disableRipple
                  sx={{
                    mt: 2,
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    color: "white",

                    backgroundColor: "#6464E5",
                    "&:hover": {
                      backgroundColor: "#E1E2E9",
                      color: "black",
                    },
                    display: "inline-block",
                  }}
                >
                  <FormattedMessage id="analytics.userView.search" />
                </Button>
                <Button
                  type="button" // Use 'button' type to prevent form submission
                  variant="contained"
                  disableRipple // Disable ripple effect
                  sx={{
                    mt: 2,
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    color: "black",

                    backgroundColor: "#E1E2E9",
                    "&:hover": {
                      backgroundColor: "#E1E2E9",
                    },

                    display: "inline-block",
                  }}
                  onClick={() => {
                    handleClearAll();
                  }}
                >
                  <FormattedMessage id="analytics.userView.clear" />
                </Button>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
      <div>
        <div className="pb-[2%]"></div>

        <div className="text-mk-very-dark-grey text-xl font-semibold">
          <FormattedMessage id="addNewUser.addUserToexistingCohort" />
        </div>
        <AddNewUsersDup
          cohortListState={props.cohortListState}
          addNewState={props.addNewState}
          addNewUpdate={() => {
            // addUpdate(currCohort);
            props.addNewUpdate();
          }}
          coh={props.coh}
          delBut={props.delBut}
          refreshedCohorts={() => {
            props.refreshedCohorts();
          }}
          userData={userFetchModel}
          userDataFunction={setUserFetchModel}
          search={searchActive}
          searchFunction={setSearchActive}
          totalCount={totalUserCount}
          totalCountFunction={setTotalUserCount}
          formData={formData}
          formDataFunction={setFormData}
          hasMoreDataReference={hasMoreData}
          currentCohort={props.currentCohort}
          selectedLanguage={selectedLanguage}
          selectedLanguageFunction={setSelectedLanguage}
          languages={languages}
        />
      </div>
    </div>
  );
}
